import SearchRequests from "./SearchRequests";

function SearchRequest() {
    return <SearchRequests />;
}

export default SearchRequest;